import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelText as _vModelText, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "account-general-row" }
const _hoisted_2 = {
  value: '',
  selected: ""
}
const _hoisted_3 = ["value"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "form__arrow" }, null, -1)
const _hoisted_5 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_6 = ["disabled"]
const _hoisted_7 = {
  value: '',
  selected: ""
}
const _hoisted_8 = ["value"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "form__arrow" }, null, -1)
const _hoisted_10 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_11 = ["disabled"]
const _hoisted_12 = {
  value: '',
  selected: ""
}
const _hoisted_13 = ["value"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "form__arrow" }, null, -1)
const _hoisted_15 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_16 = ["disabled"]
const _hoisted_17 = {
  key: 2,
  class: "error-msg"
}
const _hoisted_18 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_19 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" / ")
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" / ")
const _hoisted_22 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_23 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_24 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_25 = { class: "account-general-foot account-general-foot--alt" }
const _hoisted_26 = {
  key: 0,
  class: "error-msg"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonSave = _resolveComponent("ButtonSave")!
  const _component_ErrorPopin = _resolveComponent("ErrorPopin")!
  const _component_LeavePopin = _resolveComponent("LeavePopin")!

  return (_openBlock(), _createElementBlock("form", {
    class: "account-general form",
    onSubmit: _cache[29] || (_cache[29] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"])),
    novalidate: ""
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("fieldset", null, [
        _createElementVNode("legend", null, _toDisplayString(_ctx.$t('staff-form.country')), 1),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.address.countryId) = $event)),
          onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.v$?.form?.address?.countryId?.$touch && _ctx.v$?.form?.address?.countryId?.$touch(...args))),
          class: _normalizeClass({ 'error': _ctx.v$?.form?.address?.countryId?.$errors.length }),
          name: "country"
        }, [
          _createElementVNode("option", _hoisted_2, _toDisplayString(_ctx.$t('staff-form.select')), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countries, (countryItem) => {
            return (_openBlock(), _createElementBlock("option", {
              key: countryItem.id,
              value: countryItem.id
            }, _toDisplayString(countryItem.name), 9, _hoisted_3))
          }), 128))
        ], 34), [
          [_vModelSelect, _ctx.form.address.countryId]
        ]),
        _hoisted_4,
        (_ctx.v$?.form.address?.countryId?.$errors.length)
          ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.v$?.form.address.countryId?.$errors[0].$message), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("fieldset", null, [
        _createElementVNode("legend", null, _toDisplayString(_ctx.$t('staff-form.state')), 1),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.address.stateId) = $event)),
          disabled: _ctx.form.address.countryId !== 230,
          onBlur: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.v$?.state?.$touch && _ctx.v$?.state?.$touch(...args))),
          class: _normalizeClass({ 'error': _ctx.v$?.form.address.stateId?.$errors.length }),
          name: "state"
        }, [
          _createElementVNode("option", _hoisted_7, _toDisplayString(_ctx.$t('staff-form.select')), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.states, (stateItem) => {
            return (_openBlock(), _createElementBlock("option", {
              key: stateItem.id,
              value: stateItem.id
            }, _toDisplayString(stateItem.name), 9, _hoisted_8))
          }), 128))
        ], 42, _hoisted_6), [
          [_vModelSelect, _ctx.form.address.stateId]
        ]),
        _hoisted_9,
        (_ctx.v$?.form.address.stateId?.$errors.length)
          ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(_ctx.v$?.form.address.stateId?.$errors[0].$message), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("fieldset", null, [
        _createElementVNode("legend", null, _toDisplayString(_ctx.$t('staff-form.city')), 1),
        (_ctx.form.address.countryId === 230 )
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.address.cityId) = $event)),
                disabled: !_ctx.form.address.stateId || _ctx.form.address.stateId === 52,
                onBlur: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.v$?.city?.$touch && _ctx.v$?.city?.$touch(...args))),
                class: _normalizeClass({ 'error': _ctx.v$?.city?.$errors.length }),
                name: "city"
              }, [
                _createElementVNode("option", _hoisted_12, _toDisplayString(_ctx.$t('staff-form.select')), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.address.cities, (cityItem) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: cityItem.id,
                    value: cityItem.id
                  }, _toDisplayString(cityItem.name), 9, _hoisted_13))
                }), 128))
              ], 42, _hoisted_11), [
                [
                  _vModelSelect,
                  _ctx.form.address.cityId,
                  void 0,
                  { number: true }
                ]
              ]),
              _hoisted_14,
              (_ctx.v$?.form.address.cityId?.$errors.length)
                ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(_ctx.v$?.form.address.cityId?.$errors[0].$message), 1))
                : _createCommentVNode("", true)
            ], 64))
          : _withDirectives((_openBlock(), _createElementBlock("input", {
              key: 1,
              disabled: !_ctx.form.address.countryId,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.address.city) = $event)),
              onBlur: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.v$?.city?.$touch && _ctx.v$?.city?.$touch(...args))),
              class: _normalizeClass({ 'error': _ctx.v$?.city?.$errors.length }),
              type: "text",
              name: "city",
              spellcheck: "false",
              autocorrect: "off"
            }, null, 42, _hoisted_16)), [
              [
                _vModelText,
                _ctx.form.address.city,
                void 0,
                { trim: true }
              ]
            ]),
        (_ctx.v$?.form.address.city?.$errors.length)
          ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(_ctx.v$?.form.address.city?.$errors[0].$message), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("fieldset", null, [
        _createElementVNode("legend", null, _toDisplayString(_ctx.$t('staff-form.address')), 1),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.streetAddress) = $event)),
          onBlur: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.v$?.address?.$touch && _ctx.v$?.address?.$touch(...args))),
          class: _normalizeClass({ 'error': _ctx.v$?.address?.$errors.length }),
          type: "text",
          name: "address",
          maxlength: "255",
          spellcheck: "false",
          autocorrect: "off"
        }, null, 34), [
          [
            _vModelText,
            _ctx.form.streetAddress,
            void 0,
            { trim: true }
          ]
        ]),
        (_ctx.v$?.address?.$errors.length)
          ? (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString(_ctx.v$?.address?.$errors[0].$message), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("fieldset", null, [
        _createElementVNode("legend", null, _toDisplayString(_ctx.$t('staff-form.zip')), 1),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.zip) = $event)),
          onBlur: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.v$?.zip?.$touch && _ctx.v$?.zip?.$touch(...args))),
          class: _normalizeClass({ 'error': _ctx.v$?.zip?.$errors.length }),
          type: "text",
          name: "zip",
          minlength: "4",
          maxlength: "12",
          spellcheck: "false",
          autocorrect: "off"
        }, null, 34), [
          [_vModelText, _ctx.form.zip]
        ]),
        (_ctx.v$?.zip?.$errors.length)
          ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(_ctx.v$?.zip?.$errors[0].$message), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("fieldset", null, [
        _createElementVNode("legend", null, _toDisplayString(_ctx.$t('register-form.date')), 1),
        _createElementVNode("div", {
          class: _normalizeClass([{ 'error': _ctx.v$?.form.birthdayMonth?.$errors.length || _ctx.v$?.form.birthdayDay?.$errors.length || _ctx.v$?.form.birthdayYear?.$errors.length }, "input-date"])
        }, [
          _withDirectives(_createElementVNode("input", {
            onKeypress: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.onDateKeyPress && _ctx.onDateKeyPress(...args))),
            onKeyup: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.onDateKeyUp && _ctx.onDateKeyUp(...args))),
            onChange: _cache[14] || (_cache[14] = ($event: any) => {if(parseInt(_ctx.form.birthdayMonth,10)<10)_ctx.form.birthdayMonth='0'+_ctx.form.birthdayMonth;}),
            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.form.birthdayMonth) = $event)),
            onBlur: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.v$?.form.birthdayMonth?.$touch && _ctx.v$?.form.birthdayMonth?.$touch(...args))),
            type: "number",
            name: "birthdayMonth",
            min: "1",
            max: "12",
            size: "2",
            placeholder: "MM",
            minlength: "2",
            maxlength: "2",
            spellcheck: "false",
            autocorrect: "off"
          }, null, 544), [
            [_vModelText, _ctx.form.birthdayMonth]
          ]),
          _hoisted_20,
          _withDirectives(_createElementVNode("input", {
            onKeypress: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.onDateKeyPress && _ctx.onDateKeyPress(...args))),
            onKeyup: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.onDateKeyUp && _ctx.onDateKeyUp(...args))),
            onChange: _cache[19] || (_cache[19] = ($event: any) => {if(parseInt(_ctx.form.birthdayDay,10)<10)_ctx.form.birthdayDay='0'+_ctx.form.birthdayDay;}),
            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.form.birthdayDay) = $event)),
            onBlur: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.v$?.form.birthdayDay?.$touch && _ctx.v$?.form.birthdayDay?.$touch(...args))),
            type: "number",
            name: "birthdayDay",
            min: "1",
            max: "31",
            size: "2",
            placeholder: "DD",
            minlength: "2",
            maxlength: "2",
            spellcheck: "false",
            autocorrect: "off"
          }, null, 544), [
            [_vModelText, _ctx.form.birthdayDay]
          ]),
          _hoisted_21,
          _withDirectives(_createElementVNode("input", {
            onKeypress: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.onDateKeyPress && _ctx.onDateKeyPress(...args))),
            "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.form.birthdayYear) = $event)),
            onBlur: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.v$?.form.birthdayYear?.$touch && _ctx.v$?.form.birthdayYear?.$touch(...args))),
            type: "number",
            name: "birthdayYear",
            min: "1900",
            max: "3000",
            size: "4",
            placeholder: "YYYY",
            minlength: "4",
            maxlength: "4",
            spellcheck: "false",
            autocorrect: "off"
          }, null, 544), [
            [_vModelText, _ctx.form.birthdayYear]
          ])
        ], 2),
        (_ctx.v$?.form.birthdayMonth?.$errors.length || _ctx.v$?.form.birthdayDay?.$errors.length || _ctx.v$?.form.birthdayYear?.$errors.length)
          ? (_openBlock(), _createElementBlock("p", _hoisted_22, _toDisplayString(_ctx.$t('error.date-invalid')), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("fieldset", null, [
        _createElementVNode("legend", null, _toDisplayString(_ctx.$t('register-form.establishment')), 1),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.form.establishment) = $event)),
          onBlur: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.v$?.establishment?.$touch && _ctx.v$?.establishment?.$touch(...args))),
          class: _normalizeClass({ 'error': _ctx.v$?.establishment?.$errors.length }),
          type: "text",
          name: "establishment",
          maxlength: "255",
          spellcheck: "false",
          autocorrect: "off"
        }, null, 34), [
          [_vModelText, _ctx.form.establishment]
        ]),
        (_ctx.v$?.establishment?.$errors.length)
          ? (_openBlock(), _createElementBlock("p", _hoisted_23, _toDisplayString(_ctx.v$?.establishment?.$errors[0].$message), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("fieldset", null, [
        _createElementVNode("legend", null, _toDisplayString(_ctx.$t('register-form.position')), 1),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.form.position) = $event)),
          onBlur: _cache[28] || (_cache[28] = 
//@ts-ignore
(...args) => (_ctx.v$?.position?.$touch && _ctx.v$?.position?.$touch(...args))),
          class: _normalizeClass({ 'error': _ctx.v$?.position?.$errors.length }),
          type: "text",
          name: "position",
          maxlength: "255",
          spellcheck: "false",
          autocorrect: "off"
        }, null, 34), [
          [
            _vModelText,
            _ctx.form.position,
            void 0,
            { trim: true }
          ]
        ]),
        (_ctx.v$?.position?.$errors.length)
          ? (_openBlock(), _createElementBlock("p", _hoisted_24, _toDisplayString(_ctx.v$?.position?.$errors[0].$message), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_25, [
      _createVNode(_component_ButtonSave, {
        saved: _ctx.saved,
        loading: _ctx.isLoading,
        type: "submit",
        class: "button"
      }, {
        saved: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('account.saved')), 1)
        ]),
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('account.save')) + " ", 1)
        ]),
        _: 1
      }, 8, ["saved", "loading"]),
      (_ctx.errorMessage !== null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(_ctx.errorMessage), 1))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_ErrorPopin, { active: _ctx.errorRequest }, null, 8, ["active"]),
    _createVNode(_component_LeavePopin, {
      title: _ctx.$t('profileEdit.leaveTitle'),
      text: _ctx.$t('profileEdit.leaveText'),
      labelAccept: _ctx.$t('profileEdit.leaveAccept'),
      labelDecline: _ctx.$t('profileEdit.leaveDecline'),
      active: _ctx.showLeavePopin,
      onOnAccept: _ctx.onLeaveAccept,
      onOnDecline: _ctx.onLeaveDecline
    }, null, 8, ["title", "text", "labelAccept", "labelDecline", "active", "onOnAccept", "onOnDecline"])
  ], 32))
}